import React from 'react';
import { Card, Text, Layout, Button, Icon } from '../_primatives';
import { useNavigation } from '@react-navigation/native';

const EmptyComponent = ({ title, subtitle, buttonTitle, hideButton, route }) => {
    const navigation = useNavigation();
    const onPress = () => navigation.navigate(route.routeName, route.params);
    return (
        <>
            {title && title.length ?
                <Text category='h4'>{title}</Text>
                : undefined
            }
            {subtitle && subtitle.length ?
                <Text category='p1' style={{ marginBottom: hideButton ? undefined : 20 }}>{subtitle}</Text>
                : undefined
            }
            {!hideButton ?
                <Layout style={{ flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                    <Button onPress={onPress} status='basic' icon={(style) => <Icon {...style} name='plus-circle-outline' />}>
                        {buttonTitle}
                    </Button>
                </Layout>
                : undefined
            }
        </>
    )
}


export const NoSurveyCard = ({ title = '', subtitle = '', hideButton = false }) => (
    <EmptyComponent
        title={title}
        subtitle={subtitle}
        hideButton={hideButton}
        buttonTitle={`Create Survey`}
        route={{ routeName: 'Surveys', params: { screen: 'CreateSurvey' } }}
    />
)

